<template>
  <div>
    <vx-card>
      <ListTipoFoto :subjectPermission="subjectPermission"></ListTipoFoto>
    </vx-card>
  </div>
</template>

<script>
import ListTipoFoto from "./../../lists/ListTipoFoto";

export default {
  data() {
    return {
      subjectPermission: "Tipo de Foto",
    };
  },
  methods: {},
  components: {
    ListTipoFoto,
  },
};
</script>
